import React from "react";
import { useFFcardBank } from "./hooks/useFcardBank";
import styles from "./style/FcardBank.module.scss";
/* This example requires Tailwind CSS v2.0+ */
import { ChevronRightIcon } from "@heroicons/react/solid";

function classNames(...classes) {
  return classes.filter(Boolean).join(" ");
}

const FcardBank = ({
  arrayBanks = [],
  onDeleteClickBanks = (data) => {},
  onClickBanks = (data) => {},
}) => {
  return (
    <div>
      <ul role="list" className="">
        {arrayBanks.map((bank) => (
          <li
            key={0}
            className="col-span-1 flex shadow-md rounded-md border-2 cursor-pointer p-2 mb-3"
          >
            <div
              className={classNames(
                "flex-shrink-0 flex items-center justify-center w-16 text-white text-sm font-medium rounded-l-md border-b-1"
              )}
            >
              <img
                src={require("../../components/assets/images/bank-image.png")}
                className="w-10"
                alt=""
              />
            </div>
            <div
              className="flex-1 flex items-center justify-between border-gray-200 bg-white rounded-r-md truncate"
              onClick={() => {
                onClickBanks(bank);
              }}
            >
              <div className="flex-1 px-4 py-2 text-sm truncate text-center">
                <p className="text-black font-bold">{bank.bankName}</p>
                <p className="text-Secondary font-bold">
                  {"**** "} {bank.accountNumber.substr(-4)}
                </p>
              </div>
            </div>
          </li>
        ))}
      </ul>
    </div>
  );
};

export default FcardBank;
